import { Fragment, useState } from 'react';
import CSSModules from 'react-css-modules';
import PropTypes from 'prop-types';

import { AnalyticsEventCategory } from 'enums/analytics-types';
import { UserFeatureFlags } from 'enums/user-membership-features';
import { makeSelectUserFeature, makeSelectUserType } from 'reducers/user/selectors';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { bemClassName } from 'utils/BEMHelper';

import OnClickAnalyticEvent from 'components/OnClickAnalyticEvent';

import ConnectedInviteClientModal from 'modules/FundingDashboard/containers/ConnectedInviteClientModal/ConnectedInviteClientModal';

import QuickActionButton from './QuickActionButton';
import config from './config';

import styles from './QuickActionsNav.scss';
import { useCountryContext } from 'hooks/useCountryContext';
import { useModalContext } from 'hooks/useModalContext';

const QuickActionsNav = (props) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const { country } = useCountryContext();
  const { open } = useModalContext();

  const {
    consultant,
    hasFundingReportAccess,
    hasMonitoringAccess,
    hasLightPlan,
    hasPaidPlan,
    hasStarterPlan,
    hasPlaybookAccess,
    hasWorkingCapitalAccess,
    isRecoveryEnabled,
    isCreditImprovementEnabled,
    isRanddEnabled,
    isGrantsEnabled,
    openModal,
    openMonitorWizzard,
    openQuestionnaire,
    userType,
  } = props;

  const openUpsellModal = () => openModal('subscriptionLimit', { upsellModal: true });
  const itemsConfig = config({
    consultant,
    createFundingReport: () => (hasFundingReportAccess ? setModalOpen(true) : openUpsellModal()),
    hasPlaybookAccess,
    hasWorkingCapitalAccess,
    isRecoveryEnabled,
    isCreditImprovementEnabled,
    isRanddEnabled,
    isGrantsEnabled,
    openQuestionnaireAlpha: openQuestionnaire,
    openUpsellModal,
    hasMonitoringAccess,
    openWizzard: (monitorPath, needsAccess) =>
      !hasMonitoringAccess && !!needsAccess ? openUpsellModal() : openMonitorWizzard(monitorPath),
    userType,
    country,
    openModal: open,
  });

  const filterHiddenMenus = (item) => {
    if (!item) {
      return false;
    }

    return !item.button || !!item.button.display;
  };
  return (
    <div
      styleName={bemClassName('m-quick-action-nav', {
        pro: hasPaidPlan,
        light: hasLightPlan,
        starter: hasStarterPlan,
      })}
    >
      <ul className="o-col-block o-col-block--col-collapse u-flex">
        {itemsConfig
          .filter((item) => !!item.display)
          .map(({ items = [], title }, index) => (
            <li
              key={index}
              className={`o-col-sml-${12 / itemsConfig.length} o-col-12`}
              styleName="m-quick-action-nav__column"
            >
              {title && <h3 styleName="m-quick-action-nav__title">{title}</h3>}

              <div styleName="m-quick-action-nav__items">
                {items.filter(filterHiddenMenus).map(({ button, children }, key) => (
                  <Fragment key={key}>
                    {children}

                    {!!button && (
                      <OnClickAnalyticEvent
                        eventCategory={(button.category || '').toString()}
                        eventAction={AnalyticsEventCategory.navbarLaunch}
                        eventOptions={{ extraParams: button.extraParams || {} }}
                      >
                        <QuickActionButton {...button} />
                      </OnClickAnalyticEvent>
                    )}
                  </Fragment>
                ))}
              </div>
            </li>
          ))}
      </ul>

      <ConnectedInviteClientModal
        closeModal={() => setModalOpen(!isModalOpen)}
        isOpen={isModalOpen}
      />
    </div>
  );
};

QuickActionsNav.propTypes = {
  consultant: PropTypes.object,
  hasFundingReportAccess: PropTypes.bool,
  hasMonitoringAccess: PropTypes.bool,
  hasLightPlan: PropTypes.bool,
  hasPaidPlan: PropTypes.bool,
  hasStarterPlan: PropTypes.bool,
  hasPlaybookAccess: PropTypes.bool,
  hasWorkingCapitalAccess: PropTypes.bool,
  isRecoveryEnabled: PropTypes.bool,
  isCreditImprovementEnabled: PropTypes.bool,
  isRanddEnabled: PropTypes.bool,
  isGrantsEnabled: PropTypes.bool,
  openModal: PropTypes.func.isRequired,
  openMonitorWizzard: PropTypes.func.isRequired,
  openQuestionnaire: PropTypes.func.isRequired,
  userType: PropTypes.string,
};

const mapStateToProps = createStructuredSelector({
  isRecoveryEnabled: makeSelectUserFeature(UserFeatureFlags.featureCasesRecovery),
  isCreditImprovementEnabled: makeSelectUserFeature(UserFeatureFlags.featureCasesCreditImprovement),
  isRanddEnabled: makeSelectUserFeature(UserFeatureFlags.featureCasesRandd),
  isGrantsEnabled: makeSelectUserFeature(UserFeatureFlags.featureCasesGrants),
  userType: makeSelectUserType(),
});

export default compose(
  connect(mapStateToProps, null),
  CSSModules(styles, { allowMultiple: true, handleNotFoundStyleName: 'ignore' }),
)(QuickActionsNav);
